import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const authAxios = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
});

export default authAxios;
